export default __webpack_public_path__ + "static/media/ipco.823ee99b.png";